<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">
      <h1>
        SmartTag Finder - Privacy Notice
      </h1>
      <p class="text-muted">
        Effective Date: 1st September 2026
      </p>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">

      <p>
        This notice applies to you if you have scanned a SmartTag QR code tag and used the web page that follows (the "Finder Page"), operated by Identicare Limited of Moorside, Monks Cross Drive, Huntington, York, YO32 9LB (company number 12960490), trading as 'identi' ("we"/"us"). It is separate from, and sits alongside, our main <a [routerLink]="['/privacy']">identi Privacy Policy</a> and our SmartTag Privacy Notice, which apply to identi account holders and SmartTag keepers respectively.
      </p>
      <p>
        We are committed to protecting and respecting your privacy. We only use your personal data where the processing is supported by your consent, a legitimate interest, a contract, or a legal obligation.
      </p>
      <p>
        This notice explains what information we collect from you as a finder, why, and what your rights are.
      </p>

      <p>
        Click on the links below to go straight to more information on each area:
      </p>
      <ul>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(A1)">
            The information we collect from you
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(B1)">
            Our legal basis for processing your information
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(C1)">
            How we use your information
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(D1)">
            Who we share your information with
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(E1)">
            Where we store your information
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(F1)">
            How long we keep your information
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(G1)">
            Cookies
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(H1)">
            Our commitment to security
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(I1)">
            Your rights
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(J1)">
            How to contact us
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(K1)">
            Changes to this notice
          </a>
        </li>
      </ul>

      <h4 #A1 id="A1" class="my-3">
        The information we collect from you
      </h4>

      <p>
        If you simply view the Finder Page, we automatically collect limited technical information, such as your device or browser type, in order to operate the page securely.
      </p>
      <p>
        If you choose to share your location and/or your contact details with the pet's keeper, we will additionally collect:
      </p>
      <ul>
        <li>your approximate or precise location, captured only at the moment you choose to share it (as provided by your device) - this is not continuous tracking, and if you move you will need to share your location again, for example by scanning the tag once more; and/or</li>
        <li>your name and contact details (such as a phone number or email address), if you provide these to be passed to the keeper.</li>
      </ul>
      <p>
        You do not have to share this information. If you would rather not, you can choose instead to contact us directly, and we will pass on a message to the keeper without disclosing your details to them.
      </p>
      <p>
        This page is intended for use by individuals aged 18 and over. If you are under 18, please ask a parent, guardian or another responsible adult to contact us instead of sharing your location or contact details yourself.
      </p>

      <h4 #B1 id="B1" class="my-3">
        Our legal basis for processing your information
      </h4>

      <ul>
        <li>Where you choose to share your location and/or contact details with the keeper: your consent, given at the point you choose to share it.</li>
        <li>Where we collect limited technical information to operate the Finder Page securely: our legitimate interest in keeping the page and our systems safe and functioning correctly.</li>
      </ul>

      <h4 #C1 id="C1" class="my-3">
        How we use your information
      </h4>

      <p>
        We use the information you choose to share only to help reunite the pet with its keeper - specifically, to pass your location and/or contact details to the keeper (or, if you contact us directly, to relay a message on your behalf without disclosing your details).
      </p>
      <p>
        We do not use your information for marketing purposes, and we do not use it to build a profile about you.
      </p>

      <h4 #D1 id="D1" class="my-3">
        Who we share your information with
      </h4>

      <p>
        We share the information you choose to provide with:
      </p>
      <ul>
        <li>the pet's owner, where you have chosen to share your location and/or contact details with them; and</li>
        <li>our service providers who help us run the Finder Page (for example, hosting and mapping providers), acting on our instructions to aid reunification of the pet with their owner.</li>
      </ul>
      <p>
        <strong>We do not sell your information, and we do not share it with advertisers.</strong>
      </p>
      <p>
        We may also disclose your information where we are under a legal duty to do so - for example, to comply with a court order or a law enforcement request.
      </p>

      <h4 #E1 id="E1" class="my-3">
        Where we store your information
      </h4>

      <p>
        Information you provide is stored and processed within the UK and the EU. Where it is ever transferred to, stored or processed by a supplier outside the UK or the EEA, we ensure appropriate safeguards are in place, such as standard contractual clauses or another approved transfer mechanism.
      </p>

      <h4 #F1 id="F1" class="my-3">
        How long we keep your information
      </h4>

      <p>
        We only keep the information you share as a finder for as long as necessary to facilitate the reunification - until the report is marked resolved - after which it is deleted. Limited technical information collected automatically is kept only for as long as necessary for security and operational purposes.
      </p>

      <h4 #G1 id="G1" class="my-3">
        Cookies
      </h4>

      <p>
        The Finder Page may use Google Maps and other similar technologies, for example to support the mapping feature. Please see our <a [routerLink]="['/cookies']">Cookie Policy</a> for more information.
      </p>

      <h4 #H1 id="H1" class="my-3">
        Our commitment to security
      </h4>

      <p>
        We employ security measures to prevent unauthorised access to information that we collect. If you have any concerns that your information is incorrect or has been disclosed inappropriately, please contact us so we can investigate.
      </p>

      <h4 #I1 id="I1" class="my-3">
        Your rights
      </h4>

      <p>
        In accordance with data protection law, you have the following rights in relation to your personal data:
      </p>
      <ul>
        <li>Right of access - to be informed of, and request access to, the personal data we hold about you;</li>
        <li>Right to rectification - to ask us to correct inaccurate or incomplete data;</li>
        <li>Right to erasure - to ask us to delete your data, where we are not required to keep it;</li>
        <li>Right to restrict processing - to ask us to pause some or all processing of your data;</li>
        <li>Right to data portability - to receive your data in a portable format; and</li>
        <li>Right to object - to object to our processing of your data on grounds relating to your particular situation.</li>
      </ul>
      <p>
        If you are unhappy with how we have used your data, you have the right to complain to the Information Commissioner's Office (ICO) on 0303 123 1113 or at <a href="https://www.ico.org.uk/concerns">ico.org.uk/concerns</a>. We would appreciate the opportunity to address your concerns first - please contact us using the details below.
      </p>

      <h4 #J1 id="J1" class="my-3">
        How to contact us
      </h4>

      <p>
        If you have any questions about this notice, or wish to exercise your rights, please contact us at <a href="mailto:privacy@identicare.pet">privacy&#64;identicare.pet</a> or by phone on 0330 9128077.
      </p>

      <h4 #K1 id="K1" class="my-3">
        Changes to this notice
      </h4>

      <p>
        We may update this notice from time to time. Please check it periodically for changes.
      </p>

    </div>
  </div>

</div>
